import { render, staticRenderFns } from "./scored.vue?vue&type=template&id=379ed3e2&scoped=true"
import script from "./scored.vue?vue&type=script&lang=js"
export * from "./scored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379ed3e2",
  null
  
)

export default component.exports